import { Toast } from 'js/src/components/common/Toast';
import {
    selectSketchControlsBlueprint,
    selectSketchControlsTemplate,
} from 'js/src/data/sketch-controls/sketch-controls-selectors';
import {
    clearAspectRatio,
    clearBlueprint,
    clearNarrativeThread,
    clearTemplate,
    clearVoice,
} from 'js/src/data/sketch-controls/sketch-controls-slice';
import {
    getIncompatiblePropertyLabel,
    getVideoPlanIncompatibilities,
    type IncompatibleProperty,
    type PropertyChange,
    type VideoPlanState,
} from 'js/src/data/video-planner/video-plan-compatibility';
import type { AppDispatch, GetRootState } from 'js/src/libs/RootState';

const CLEAR_ACTIONS: Record<IncompatibleProperty, () => { type: string }> = {
    aspectRatio: clearAspectRatio,
    template: clearTemplate,
    voice: clearVoice,
    blueprint: clearBlueprint,
    narrativeThread: clearNarrativeThread,
};

export function clearIncompatibleSketchControls(
    change: PropertyChange,
    { showToast = true }: { showToast?: boolean } = {},
) {
    return (dispatch: AppDispatch, getState: GetRootState) => {
        const state = getState();
        const currentState: Partial<VideoPlanState> = {
            aspectRatio: state.sketchControls?.aspectRatio ?? null,
            template: selectSketchControlsTemplate(state),
            blueprint: selectSketchControlsBlueprint(state) ?? null,
            narrativeThread: state.sketchControls?.narrativeThread ?? null,
            voiceSlug: state.sketchControls?.voiceId ?? null,
        };
        const incompatibilities = getVideoPlanIncompatibilities(change, currentState);
        for (const incompatibility of incompatibilities) {
            if (showToast) {
                const label = getIncompatiblePropertyLabel(incompatibility.property);
                Toast.info(
                    `${label} is not compatible with selected ${change.type}. ${label} has been cleared.`,
                );
            }
            dispatch(CLEAR_ACTIONS[incompatibility.property]());
        }
    };
}
